// extracted by mini-css-extract-plugin
module.exports = {"job_title":"experience_job_title__3b5TR","coursework":"experience_coursework__AmDhu","tufts":"experience_tufts__2fFNX"};